import {ApplicantDataInterface} from "../interfaces/ApplicantDataInterface";

export const applicantFields = (applicantData: ApplicantDataInterface, setApplicantData: (data: ApplicantDataInterface) => void, applicantFieldsDisabled: boolean) => {
    return [
        {
            name: 'name',
            label: 'Naam',
            type: 'text',
            value: applicantData.name,
            disabled: applicantFieldsDisabled,
            required: true,
            onChange: (data: HTMLInputElement) => setApplicantData({...applicantData, name: data.value})
        },
        {
            name: 'company',
            label: 'Bedrijf',
            type: 'text',
            value: applicantData.company,
            disabled: applicantFieldsDisabled,
            required: true,
            onChange: (data: HTMLInputElement) => setApplicantData({...applicantData, company: data.value})
        },
        {
            name: 'email',
            label: 'Email',
            type: 'email',
            value: applicantData.email,
            disabled: applicantFieldsDisabled,
            required: true,
            onChange: (data: HTMLInputElement) => setApplicantData({...applicantData, email: data.value})
        },
        {
            name: 'phone',
            label: 'Telefoon',
            type: 'tel',
            value: applicantData.phone,
            disabled: applicantFieldsDisabled,
            required: true,
            onChange: (data: HTMLInputElement) => setApplicantData({...applicantData, phone: data.value})
        }
    ]
}